import React from 'react'
import { Form, Select, Button, Input, InputNumber, Cascader } from 'antd'
import { findHostNameByAgentId } from '../../../utils'
import styled from 'styled-components'
import { t } from '@/i18n'
import { BasSwitch } from '@/components'

const dportOptions = [
  { label: '23001', value: 23001 },
  { label: '23002', value: 23002 },
  { label: '23003', value: 23003 },
  { label: '23004', value: 23004 },
  { label: '23005', value: 23005 },
  { label: '23006', value: 23006 },
  { label: '23007', value: 23007 },
  { label: '23008', value: 23008 },
  { label: '23009', value: 23009 },
  { label: '23010', value: 23010 },
]

// IP地址正则表达式
const ipPattern =
  /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/

const agentDisplayRender = (labels: string[], selectedOptions?: any[]) => {
  if (!selectedOptions || selectedOptions.length < 3) return labels.join(' / ')

  const agent = selectedOptions[2]
  return agent?.selectedLabel
}

const listenerDisplayRender = (labels: string[], selectedOptions?: any[]) => {
  if (!selectedOptions || selectedOptions.length < 3) return labels.join(' / ')

  const host = selectedOptions[2]
  const hostIp = selectedOptions[3]?.value
  return `${host.selectedLabel} / ${hostIp || ''}`
}

const ContainerAgentToListenerConfig: React.FC<{
  dataOptions?: any
  onAgentChange?: (agentId: string) => void
}> = ({ dataOptions, onAgentChange }) => {
  const form = Form.useFormInstance()
  const [natModeEnabled, setNatModeEnabled] = React.useState(false)

  // 处理agent选择变化
  const handleAgentChange = (value: (string | number)[]) => {
    if (value && value.length === 3) {
      const agentId = String(value[2])
      const hostName = findHostNameByAgentId(agentId, dataOptions?.agentOptions || [])

      // 自动填充容器地址
      form.setFieldsValue({
        verificationMode: {
          agentToContainer: {
            hostId: hostName,
          },
        },
      })

      // 通知父组件agent选择变化，用于获取设备列表
      onAgentChange?.(agentId)
    }
  }

  return (
    <Wrapper>
      <ConfigTitle>
        <div>
          <span className="config-title-label">{t('配置模式')}</span>
          <span className="config-title-value">{t('容器Agent → Listener')}</span>
        </div>
        <Form.Item
          label={<span style={{ fontSize: 12 }}>{t('NAT模式')}</span>}
          name={['verificationMode', 'containerToListener', 'nat']}
          valuePropName="checked"
          style={{ margin: 0 }}
        >
          <BasSwitch onChange={setNatModeEnabled} />
        </Form.Item>
      </ConfigTitle>

      <div className="form-item-wrapper">
        <Form.Item
          label={
            <div className="config-title-label-wrapper">
              <div className="config-title-label">{t('攻击主体')}</div>
              <div className="config-title-value" style={{ marginRight: 16 }}>
                Agent
              </div>
            </div>
          }
          name={['verificationMode', 'containerToListener', 'agentId']}
          rules={[{ required: true, message: t('请选择攻击主体') }]}
          required
        >
          <Cascader
            placeholder={t('Agent名称/IP')}
            className="form-select"
            options={dataOptions?.agentOptions || []}
            displayRender={agentDisplayRender}
            onChange={handleAgentChange}
          />
        </Form.Item>
        <Button type="link" onClick={() => window.open('/configure/client/list')}>
          {t('添加')}
        </Button>
      </div>

      <div className="form-item-wrapper">
        <Form.Item
          label={
            <div className="config-title-label-wrapper">
              <div className="config-title-label">{t('目标主体')}</div>
              <div className="config-title-value">Listener</div>
            </div>
          }
          name={['verificationMode', 'containerToListener', 'listenerHostId']}
          rules={[{ required: true, message: t('请选择目标主体') }]}
          required
        >
          <Cascader
            placeholder={t('监听主机名称/IP')}
            className="form-select"
            style={{ width: 455 }}
            options={dataOptions?.listenerOptions || []}
            displayRender={listenerDisplayRender}
          />
        </Form.Item>
        <Form.Item
          name={['verificationMode', 'containerToListener', 'dport']}
          label="DPORT"
          style={{ marginLeft: 24 }}
        >
          <Select
            placeholder="DPORT"
            virtual={false}
            className="dport-input"
            options={dportOptions}
          />
        </Form.Item>
      </div>

      {natModeEnabled && (
        <div className="form-item-wrapper">
          <Form.Item
            className="dnat-ip-form-item"
            name={['verificationMode', 'containerToListener', 'dnatIp']}
            label={
              <div className="config-title-label-wrapper" style={{ marginLeft: 12 }}>
                <div className="config-title-label" style={{ opacity: 0 }}>
                  {t('目标主体')}
                </div>
                <div className="config-title-value">DNAT</div>
              </div>
            }
            rules={[
              { required: true, message: t('请输入DNAT') },
              { pattern: ipPattern, message: t('请输入正确的IP地址') },
            ]}
          >
            <Input placeholder={t('请输入')} style={{ width: 455, marginLeft: 14 }} />
          </Form.Item>
          <Form.Item
            className="dnat-port-form-item"
            name={['verificationMode', 'containerToListener', 'dnatPort']}
            label="DPORT"
            style={{ marginLeft: 24 }}
            rules={[{ required: true, message: t('请输入DPORT') }]}
          >
            <InputNumber placeholder="DPORT" className="dport-input" min={1} max={65535} />
          </Form.Item>
        </div>
      )}
    </Wrapper>
  )
}

export default ContainerAgentToListenerConfig

const Wrapper = styled.div`
  min-height: 162px;
  background: #f8f9fb;
  border-radius: 6px;
  padding: 16px 16px 0 24px;
  margin: 0 0 12px 115px;

  .form-item-wrapper {
    display: flex;

    .ant-btn {
      margin-left: 16px;
      padding: 6.6px 0;
    }
    .ant-form-item-label > label {
      font-weight: 400;
    }
  }

  .config-title-label-wrapper {
    display: flex;
    align-items: center;
  }

  .config-title-label {
    color: #333333;
    margin-right: 50px;
  }

  .config-title-value {
    color: #666666;
  }

  .form-select {
    width: 640px;
  }

  .dport-input {
    width: 160px;
  }

  .dnat-ip-form-item {
    .ant-form-item-explain-error {
      margin-left: 14px;
    }
  }

  .dnat-ip-form-item,
  .dnat-port-form-item {
    .ant-form-item-required.ant-form-item-no-colon {
      :before {
        content: none;
        display: none;
      }
    }
  }
`

const ConfigTitle = styled.div`
  font-size: 14px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .config-title-label {
    color: #333333;
    margin-left: 10px;
    margin-right: 50px;
  }

  .config-title-value {
    color: #86909c;
  }
`
